import { useLang } from "../i18n/LanguageContext";
import { LANGS } from "../i18n/translations";

export default function LangSwitcher({ mobile = false }) {
  const { lang, setLang } = useLang();

  return (
    <div
      data-testid="lang-switcher"
      role="group"
      aria-label="Idioma / Idioma / Language"
      className={`flex items-center rounded-full border border-federasol-terra/20 bg-white/70 p-1 ${mobile ? "w-fit" : ""}`}
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          className={`rounded-full px-3 py-1.5 text-[11px] font-bold tracking-wider transition-all duration-300 ease-soft ${
            lang === l.code
              ? "bg-federasol-rose text-white shadow-[0_4px_12px_-2px_rgba(197,120,135,0.6)]"
              : "text-federasol-terra hover:text-federasol-cocoa"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
